/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { LogbookElement } from './logbook-element';
import { BehaviorSubject } from 'rxjs';
import { CommonUtils } from '../../tool/common-utils';

/**
 * Representation of data on {@link LogbookComponent}
 */
export class Logbook {
  public indiceField: string;
  public dateField: string;
  public timeField: string;
  public authorField: string;
  public changeField: string;
  public contentField: string;
  public iconField: string;
  private subject = new BehaviorSubject<LogbookElement[]>([]);

  constructor(
    contentField: string,
    dateField: string,
    authorField?: string,
    timeField?: string,
    changeField?: string,
    indiceField?: string,
    iconField?: string,
  ) {
    this.contentField = contentField;
    this.dateField = dateField;
    this.authorField = authorField;
    this.timeField = timeField;
    this.changeField = changeField;
    this.indiceField = indiceField;
    this.iconField = iconField;
  }

  private _data: any[] = [];

  get data(): any[] {
    return this._data;
  }

  set data(value: any[]) {
    this._data = value;
  }

  public subscribe(success: (elements: LogbookElement[]) => void) {
    this.subject.subscribe(success);
  }

  /**
   * Convert any data to LobBookElement array
   */
  public build(order: 'asc' | 'desc' = 'desc'): LogbookElement[] {
    const elements = [];
    let index = 1;
    for (const line of this._data) {
      const row = order === 'asc' ? index : this._data.length - (index - 1);
      elements.push(this.factory(line, row));
      ++index;
    }
    return elements;
  }

  public notify(order?: 'asc' | 'desc') {
    this.subject.next(this.build(order));
  }

  /**
   * Convert an object to LogbookElement
   */
  public factory(data: any, index: number): LogbookElement {
    return new LogbookElement(
      this.indiceField ? this.getFactoryData(this.indiceField, data) : index,
      this.getFactoryDate(data),
      this.iconField ? this.getFactoryData(this.iconField, data) : true,
      this.authorField ? this.getFactoryData(this.authorField, data) : '',
      this.getFactoryData(this.contentField, data),
      this.changeField ? data[this.changeField] : null,
    );
  }

  public getFactoryDate(data) {
    const date = this.timeField
      ? CommonUtils.convertStrToDateTime(
          this.getFactoryData(this.dateField, data),
          this.getFactoryData(this.timeField, data),
        )
      : CommonUtils.convertStrToDate(this.getFactoryData(this.dateField, data));
    return date instanceof Date && !isNaN(date.getTime()) ? date : null;
  }

  /**
   * Convert Data
   */
  public getFactoryData(fields, data): any {
    if (data) {
      const splitArray = fields.split('.');
      let temp = data;
      for (const field of splitArray) {
        temp = temp[field];
        if (temp === undefined) {
          break;
        }
      }
      return temp;
    } else {
      return null;
    }
  }
}
